import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { PDFViewer } from '@react-pdf/renderer';
import LeaveRequestPDF from './LeaveRequestPDF';
import LeaveAcceptedPDF from './LeaveAcceptedPDF';
import AbsenceAuthorizationPDF from './AbsenceAuthorizationPDF';
import { getLeaveById } from '../services/leaves';

const PDFModalLeave = ({ open, onClose, type, data }) => {
  const [resolved, setResolved] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      if (!open) { setResolved(null); return; }
      // Utiliser directement les données initiales
      setResolved(data || null);
    };
    run();
    return () => { mounted = false; };
  }, [open, data]);

  const docData = resolved || data;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        {type === 'accepted' ? (
          (() => {
            const leaveType = docData?.leave?.type || docData?.type;
            
            // Types de congés (avec référence)
            const congeTypes = ['annuel', 'sans_solde'];
            
            // Types d'absences (sans référence)
            const absenceTypes = ['maladie', 'maternite', 'recuperation', 'accident_travail', 'mariage', 'deces_famille', 'formation', 'evenement_familial_naissance', 'evenement_familial_circoncision', 'autre'];
            
            if (congeTypes.includes(leaveType)) {
              return 'Titre de Congé';
            } else if (absenceTypes.includes(leaveType)) {
              return 'Autorisation d\'Absence';
            } else {
              return 'Autorisation d\'Absence';
            }
          })()
        ) : 
          'Demande de Congé'
        }
      </DialogTitle>
      <DialogContent>
        <PDFViewer style={{ width: '100%', height: '600px' }}>
          {type === 'accepted' ? (
            // Pour les congés acceptés, vérifier le type
            (() => {
              const leaveType = docData?.leave?.type || docData?.type;
              
              // Types de congés (avec référence)
              const congeTypes = ['annuel', 'sans_solde'];
              
              // Types d'absences (sans référence)
              const absenceTypes = ['maladie', 'maternite', 'recuperation', 'accident_travail', 'mariage', 'deces_famille', 'formation', 'evenement_familial_naissance', 'evenement_familial_circoncision', 'autre'];
              
              if (congeTypes.includes(leaveType)) {
                return <LeaveAcceptedPDF data={docData} />;
              } else if (absenceTypes.includes(leaveType)) {
                return <AbsenceAuthorizationPDF data={docData} />;
              } else {
                return <AbsenceAuthorizationPDF data={docData} />;
              }
            })()
          ) : (
            // Pour les demandes, toujours utiliser LeaveRequestPDF
            <LeaveRequestPDF data={docData} />
          )}
        </PDFViewer>
      </DialogContent>
    </Dialog>
  );
};

export default PDFModalLeave;
